import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePaymentModel } from "../paymentModel";
import { IPaymentDetail } from "../paymentService";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = usePaymentModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IPaymentDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '门店编码',
            width: 120,
            dataIndex: 'shopCode',
            fixed: "left",
        }, {
            title: '门店名称',
            width: 160,
            dataIndex: 'shopName',
            fixed: "left",
        }, {
            title: '客户、供应商编码',
            width: 120,
            dataIndex: 'partnerCode',
        }, {
            title: '客户、供应商名称',
            width: 160,
            dataIndex: 'partnerName',
            ellipsis: true
        }, {
            title: '账户编码',
            width: 120,
            dataIndex: 'code',
        }, {
            title: '账户名称',
            width: 160,
            dataIndex: 'name',
        }, {
            title: '账户挂账金额',
            width: 120,
            dataIndex: 'usedAmount',
        }, {
            title: '未核销单据金额',
            width: 120,
            dataIndex: 'sumAmount',
        }, {
            title: '差异金额',
            width: 100,
            dataIndex: 'diffAmount',
        }
    ];


    // //点击行选高亮
    // const onRow = (id: string) => {
    //     if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
    //         setSelectedRowKeys([]);
    //     } else {
    //         setSelectedRowKeys([id]);
    //     }
    // };

    return (
        <Table
            rowKey={record => record.id}
            // rowSelection={{
            //     type: "radio",
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IPaymentDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys as string[]);
            //     }
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content' }}
        />
    )
}
